"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBankHoliday = isBankHoliday;
const us_federal_holidays_1 = require("@18f/us-federal-holidays");
// Federal Reserve schedule: Sunday holidays shift to Monday, Saturday ones do not
const bankHolidayOptions = {
    shiftSaturdayHolidays: false,
    shiftSundayHolidays: true,
    utc: true,
};
function isBankHoliday(date) {
    const calendarDay = new Date(Date.UTC(date.year, date.month - 1, date.day));
    return (0, us_federal_holidays_1.isAHoliday)(calendarDay, bankHolidayOptions);
}
//# sourceMappingURL=bank-holidays.js.map